module.exports = __webpack_public_path__ + "img/vegetable-chickpeas-350x184.4f0730cc.jpg";